const baseTestId = 'purchase-popup';

export const getPurchasePopupDataTestId = (testId: string) => `${baseTestId}-${testId}`;
